import GroupCard from './GroupCard';

export default GroupCard;
